import useLoggedUser from '@/features/auth/hooks/useLoggedUser'
import useCurrentMarket from '@/features/caching/hooks/useCurrentMarket'
import { TranslationBundles } from '@/features/sitecore/configs/translation-bundles'
import { useSitecoreState } from '@/features/sitecore/store/useSitecoreState'
import { useEnvironmentState } from '@/utils/environment/store/useEnvironmentState'
import { Name, _provideUrl, _resolvePageDestination } from '../lib/url-provider'

export const useUrlProvider = () => {
	const market = useCurrentMarket()
	const user = useLoggedUser()
	const environmentState = useEnvironmentState()
	const endpoint = environmentState.getStringOrThrow('WEBSPHERE_BASE_ENDPOINT') + '/shop'
	const sitecoreStore = useSitecoreState((state) => state)

	return (name: Name, params?: { [key: string]: any }) => {
		const pageActivationKey = sitecoreStore.getLabel(TranslationBundles.FEATURES_ACTIVATION, `MSC-${name.toUpperCase()}-PAGE-ACTIVATION`, '')
		const pageName = _resolvePageDestination(name, market, pageActivationKey, user)
		return _provideUrl(pageName, market, params, endpoint)
	}
}
